<template>
  <div id="doc-download" v-loading="isLoading">
    <document-download-form />
  </div>
</template>

<script>
import DocumentDownloadForm from './components/DocumentDownloadForm.vue'

export default {
  name: 'DocumentDownload',
  components: {
    DocumentDownloadForm
  },
  computed: {
    isLoading() {
      return this.getLoading
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles/index.scss';
</style>
